import { useQuery } from '@tanstack/react-query';

import { getUserPermissions } from '@/infrastructure/network/data/permissions/permissions';
import { useOrganizationStore } from '@/store/organization-store';

export const useUserPermissionQuery = () => {
	const store = useOrganizationStore();
	return useQuery({
		queryKey: ['USER_PERMISSION', store.teamLeagueUuid],
		queryFn: () => getUserPermissions({ teamLeagueUuid: store.teamLeagueUuid }),
		enabled: !!store.teamLeagueUuid
	});
};
